export default __webpack_public_path__ + "static/media/epsFUSDT.c97cf737.png";